import AirtableDashboard from "../components/AirtableDashboard";

const Dashboard = () => {
    return (
        <div className="p-6">
            <AirtableDashboard />
        </div>
    );
};

export default Dashboard;